import { locale as translationMap } from './locales/en';

export class I18n {
  static localePath: string;

  static locale = 'en';

  static translate(key: string): string {
    const path = [this.locale, ...key.split('.')];

    return path.reduce((memo, k) => memo && memo[k], translationMap);
  }
}
